import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useNavigate, Link } from 'react-router-dom';
import { Button as Button$1 } from 'primereact/button';
import { IconUtils } from 'primereact/utils';
import clsx from 'clsx';

function Button(props) {
  const navigate = useNavigate();
  const {
      to,
      tertiary,
      iconSize,
      size,
      className,
      onClick,
      contrast,
      iconButton,
      type
    } = props,
    rest = __rest(props, ["to", "tertiary", "iconSize", "size", "className", "onClick", "contrast", "iconButton", "type"]);
  const handleOnClick = e => {
    if (to) {
      navigate(to);
    }
    if (onClick) {
      onClick(e);
    }
  };
  const buttonClass = clsx(className, to || rest.link ? 'link' : null, iconSize ? "".concat('icon-size-' + iconSize) : null, rest.iconPos ? 'icon-position-' + rest.iconPos : '', size ? 'button-size-' + size : '', iconButton ? 'icon-button' : null, {
    tertiary
  }, {
    'p-button-contrast': contrast
  });
  const renderAsLink = Boolean(to) && !rest.disabled && !rest.loading && !rest.tooltip && !rest.badge && !rest.children;
  if (to && renderAsLink) {
    const {
      label,
      icon,
      iconPos = 'left',
      severity,
      outlined,
      text,
      link,
      raised,
      rounded,
      plain,
      style,
      id,
      title,
      tabIndex,
      'aria-label': ariaLabel
    } = rest;
    const linkClass = clsx('p-button p-component', buttonClass, {
      'p-button-icon-only': Boolean(icon) && !label,
      'p-button-vertical': (iconPos === 'top' || iconPos === 'bottom') && Boolean(label),
      'p-button-outlined': outlined,
      'p-button-raised': raised,
      'p-button-link': link,
      'p-button-text': text,
      'p-button-rounded': rounded,
      'p-button-plain': plain
    }, size ? "p-button-".concat(size) : null, severity ? "p-button-".concat(severity) : null);
    return jsxs(Link, {
      to: to,
      className: linkClass,
      style: style,
      id: id,
      title: title,
      tabIndex: tabIndex,
      "aria-label": ariaLabel,
      onClick: onClick,
      children: [IconUtils.getJSXIcon(icon, {
        className: clsx('p-button-icon p-c', label ? "p-button-icon-".concat(iconPos) : null)
      }, {
        props
      }), label ? jsx("span", {
        className: "p-button-label p-c",
        children: label
      }) : jsx("span", {
        className: "p-button-label p-c",
        dangerouslySetInnerHTML: {
          __html: '&nbsp;'
        }
      })]
    });
  }
  return jsx(Button$1, Object.assign({
    className: buttonClass,
    onClick: e => handleOnClick(e),
    type: type !== null && type !== void 0 ? type : 'button'
  }, rest));
}

export { Button };
